import React from 'react'
import DashboardEditableRow from '@components/pages/Dashboard/DashboardEditableRow.component'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import DashboardMetricItem from '@components/pages/Dashboard/DashboardMetricItem.component'
import type { DashboardMetricItemData } from '../../../../../types/dashboardMetrics.types'
import {
  hasNonZeroDashboardValues,
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import { metricDataToItemProps } from '@utils/dashboardMetrics.util'

type OwnerKpiMetricsProps = {
  editMode?: boolean
  metrics: DashboardMetricItemData[]
  loading: boolean
  /** True once the responses backing these metrics have arrived. */
  hasPayload?: boolean
  hiddenSections: Set<string>
}

export function OwnerKpiMetrics({
  editMode = false,
  metrics,
  loading,
  hasPayload = false,
  hiddenSections,
}: OwnerKpiMetricsProps): React.ReactElement | null {
  const visible = metrics.filter(
    (metric) => !hiddenSections.has(metric.leftLabel ?? ''),
  )
  if (visible.length === 0) return null

  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <DashboardEditableRow
      editMode={editMode}
      className="dashboard-overview-cards-row"
    >
      {pending ? (
        <DashboardSectionCard
          loading
          skeleton={{ metrics: 4, block: 'none' }}
        />
      ) : (
        visible.map((metric) => (
          <DashboardSectionCard
            key={metric.id ?? metric.leftLabel}
            isEmpty={shouldShowDashboardSectionEmpty(
              loading,
              hasNonZeroDashboardValues(metric.value),
            )}
          >
            <DashboardMetricItem {...metricDataToItemProps(metric)} />
          </DashboardSectionCard>
        ))
      )}
    </DashboardEditableRow>
  )
}
